import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "./index.css";

import("./bootstrap");

window.isMobile = true;

export {};
